module.exports = "/images/mountain_right_1x.png";